import store from 'src/js/store';
import hideAnchors from '../actions/hide-anchors';

const hide = () => {
  store.dispatch(hideAnchors());
};

export default hide;
